export default __webpack_public_path__ + "party-icon.png";